import { createElementVNode as _createElementVNode, vModelCheckbox as _vModelCheckbox, withDirectives as _withDirectives, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, vModelSelect as _vModelSelect, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-052366ee"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "table-selection" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h1", null, "Table Selection", -1))
const _hoisted_3 = { class: "form-group" }
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { for: "allDb" }, "All Tables", -1))
const _hoisted_5 = { class: "checkbox-wrapper" }
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", null, "Table Names", -1))
const _hoisted_7 = { class: "label-checkbox-container" }
const _hoisted_8 = ["value", "id"]
const _hoisted_9 = ["for"]
const _hoisted_10 = { class: "pullMethod-dropdown" }
const _hoisted_11 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { for: "pullMethod" }, "Pull Method:", -1))
const _hoisted_12 = { class: "navigation" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _hoisted_2,
    _createElementVNode("div", _hoisted_3, [
      _hoisted_4,
      _createElementVNode("div", _hoisted_5, [
        _withDirectives(_createElementVNode("input", {
          type: "checkbox",
          "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ($setup.allTablesCheckbox = $event)),
          id: "allTablesCheckbox"
        }, null, 512), [
          [_vModelCheckbox, $setup.allTablesCheckbox]
        ])
      ]),
      _hoisted_6,
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.tableNames, (tableName) => {
        return (_openBlock(), _createElementBlock("div", {
          class: "checkbox-wrapper",
          key: tableName
        }, [
          _createElementVNode("div", _hoisted_7, [
            _withDirectives(_createElementVNode("input", {
              type: "checkbox",
              "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ($setup.selectedTableNames = $event)),
              value: tableName,
              id: 'checkbox-' + tableName
            }, null, 8, _hoisted_8), [
              [_vModelCheckbox, $setup.selectedTableNames]
            ]),
            _createElementVNode("label", {
              for: 'checkbox-' + tableName
            }, _toDisplayString(tableName), 9, _hoisted_9)
          ])
        ]))
      }), 128)),
      _createElementVNode("div", _hoisted_10, [
        _hoisted_11,
        _withDirectives(_createElementVNode("select", {
          "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ($setup.selectedPullMethod = $event)),
          id: "pullMethod"
        }, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($data.pullMethods, (pullMethod) => {
            return (_openBlock(), _createElementBlock("option", { key: pullMethod }, _toDisplayString(pullMethod), 1))
          }), 128))
        ], 512), [
          [_vModelSelect, $setup.selectedPullMethod]
        ])
      ])
    ]),
    _createElementVNode("div", _hoisted_12, [
      _createElementVNode("button", {
        onClick: _cache[3] || (_cache[3] = 
//@ts-ignore
(...args) => ($setup.goBack && $setup.goBack(...args)))
      }, "Back"),
      _createElementVNode("button", {
        onClick: _cache[4] || (_cache[4] = 
//@ts-ignore
(...args) => ($setup.finish && $setup.finish(...args)))
      }, "Finish")
    ])
  ]))
}